export enum DependentsAnalyticsEnum {
  DEPENDENTS_VIEW_PAGE = '[PAC WEB] Dependentes - Página visualizada',
  DEPENDENTS_VIEW_EMPTY_STATE = '[PAC WEB] Dependentes - Estado vazio visualizado',
  DEPENDENTS_CLICK_ADD_DEPENDENT = '[PAC WEB] Dependentes - Clicou em "Adicionar dependente"',
  DEPENDENTS_CLICK_EDIT_DEPENDENT = '[PAC WEB] Dependentes - Clicou em "Editar"',
  DEPENDENTS_CLICK_DELETE_DEPENDENT = '[PAC WEB] Dependentes - Clicou em "Excluir"',
  DEPENDENTS_OPEN_DELETE_CONFIRMATION_SHEET = '[PAC WEB] Dependentes - Modal de exclusão aberto',
  DEPENDENTS_CONFIRM_DELETE = '[PAC WEB] Dependentes - Confirmou exclusão no modal',
  DEPENDENTS_CANCEL_DELETE = '[PAC WEB] Dependentes - Cancelou exclusão no modal',
  DEPENDENTS_DELETE_SUCCESS = '[PAC WEB] Dependentes - Dependente excluído com sucesso',
  DEPENDENTS_DELETE_ERROR = '[PAC WEB] Dependentes - Erro ao excluir dependente',
  DEPENDENTS_CLICK_PRIVACY_POLICY_LINK = '[PAC WEB] Dependentes - Clicou em "Política de Privacidade" no modal de exclusão',

  DEPENDENTS_VIEW_NEW_PAGE = '[PAC WEB] Dependentes - Novo - Página visualizada',
  DEPENDENTS_NEW_FORM_SUBMIT = '[PAC WEB] Dependentes - Cadastrou dependente',
  DEPENDENTS_NEW_SUCCESS = '[PAC WEB] Dependentes - Novo - Dependente criado com sucesso',
  DEPENDENTS_NEW_ERROR = '[PAC WEB] Dependentes - Novo - Erro ao criar dependente',
  DEPENDENTS_NEW_DISCARD_CHANGES = '[PAC WEB] Dependentes - Novo - Descartou alterações no modal',
  DEPENDENTS_NEW_KEEP_EDITING = '[PAC WEB] Dependentes - Novo - Continuou editando no modal',

  DEPENDENTS_VIEW_EDIT_PAGE = '[PAC WEB] Dependentes - Editar - Página visualizada',
  DEPENDENTS_EDIT_FORM_SUBMIT = '[PAC WEB] Dependentes - Editou dependente',
  DEPENDENTS_EDIT_SUCCESS = '[PAC WEB] Dependentes - Editar - Dependente atualizado com sucesso',
  DEPENDENTS_EDIT_ERROR = '[PAC WEB] Dependentes - Editar - Erro ao atualizar dependente',
  DEPENDENTS_EDIT_DISCARD_CHANGES = '[PAC WEB] Dependentes - Editar - Descartou alterações no modal',
  DEPENDENTS_EDIT_KEEP_EDITING = '[PAC WEB] Dependentes - Editar - Continuou editando no modal',
}
